const navigation = [
  {
    id: "0",
    label: "Map",
    path: "/map",
  },
  {
    id: "1",
    label: "Camera",
    path: "/settings/camera",
  },
  /*  {
    id: "1",
    label: "Incidents",
    path: "/incidents",
  }, */
  {
    id: "2",
    label: "Incident Type",
    path: "/settings/incident-type",
    data: [
      {
        id: "2-1",
        label: "Category",
        path: "/settings/incident-type/category",
      },
      {
        id: "2-2",
        label: "Subcategory",
        path: "/settings/incident-type/subcategory",
      },
    ],
  },
  {
    id: "3",
    label: "Incident",
    path: "/settings/incident",
    data: [
      {
        id: "3-1",
        label: "Priority",
        path: "/settings/incident/priority",
      },
      {
        id: "3-2",
        label: "Severity",
        path: "/settings/incident/severity",
      },
      {
        id: "3-3",
        label: "Status",
        path: "/settings/incident/status",
      },
    ],
  },
  {
    id: "4",
    label: "SOP",
    path: "/settings/sop",
  },
  {
    id: "5",
    label: "Users",
    path: "/settings/users",
  },
  {
    id: "6",
    label: "Workflow",
    path: "/settings/workflow",
  },
];

export default navigation;
